import { Helmet } from 'react-helmet-async';
import Conversions from 'src/sections/overview/dashboards/views/funnel/conversions';

export default function SearchPerformanceClusterManager() {
  return (
    <>
      <Helmet>
        <title>Conversions</title>
      </Helmet>

      <Conversions />
    </>
  );
}
